import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { History as HistoryIcon } from "lucide-react";
import api from "@/lib/api";
import StatusHistoryList from "@/components/StatusHistoryList";

/**
 * Popover with a trip's `status_history` timeline. Lists in the History
 * table are projected without status_history (to keep paging fast), so when
 * the field is missing we fetch the single trip on open — one request, only
 * when the user actually asks for it.
 */
export default function StatusHistoryButton({ trip, size = "sm" }) {
  const [fetched, setFetched] = useState(null);
  const [loading, setLoading] = useState(false);
  const inline = Array.isArray(trip.status_history) && trip.status_history.length > 0 ? trip.status_history : null;
  const history = inline ?? fetched ?? [];

  const onOpenChange = async (open) => {
    if (!open || inline || fetched || !trip.id) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/trips/${trip.id}`);
      setFetched(Array.isArray(data.status_history) ? data.status_history : []);
    } catch {
      setFetched([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popover onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button
          size={size}
          variant="outline"
          data-testid={`history-trip-${trip.id}`}
          className={`border-border ${size === "sm" ? "h-6 w-6" : "h-7 w-7"} p-0 text-muted-foreground hover:text-foreground`}
          title="Ver historial de estados y ediciones"
        >
          <HistoryIcon className="w-3 h-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-card border-border" data-testid={`history-popover-${trip.id}`}>
        <div className="px-3 py-2 border-b border-border">
          <div className="text-[10px] font-mono text-muted-foreground tracking-widest">HISTORIAL DE ESTADOS</div>
          <div className="text-xs font-semibold">
            {trip.trip_number ? `#${trip.trip_number} · ` : ""}{trip.passenger_name || "Sin nombre"}
          </div>
        </div>
        <div className="max-h-80 overflow-y-auto p-2">
          <StatusHistoryList history={history} loading={loading} testId={`history-list-${trip.id}`} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
